import { GlModal, GlSprintf, GlFormInput } from '@gitlab/ui';
import { __, n__ } from '~/locale';
import { REMOVE_TAG_CONFIRMATION_TEXT, REMOVE_TAGS_CONFIRMATION_TEXT, DELETE_IMAGE_CONFIRMATION_TITLE, DELETE_IMAGE_CONFIRMATION_TEXT } from '../constants';
import { getImageName } from '../utils';
export default {
    name: 'DeleteModal',
    components: {
        GlModal,
        GlSprintf,
        GlFormInput
    },
    props: {
        itemsToBeDeleted: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        deleteImage: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'cancel-delete',
        'confirm-delete'
    ],
    expose: [
        'show'
    ],
    data () {
        return {
            inputImageName: ''
        };
    },
    computed: {
        imageName () {
            const [item] = this.itemsToBeDeleted;
            return getImageName(item);
        },
        modalTitle () {
            if (this.deleteImage) {
                return DELETE_IMAGE_CONFIRMATION_TITLE;
            }
            return n__('ContainerRegistry|Remove tag', 'ContainerRegistry|Remove tags', this.itemsToBeDeleted.length);
        },
        modalDescription () {
            if (this.deleteImage) {
                return {
                    message: DELETE_IMAGE_CONFIRMATION_TEXT,
                    item: this.imageName
                };
            }
            if (this.itemsToBeDeleted.length > 1) {
                return {
                    message: REMOVE_TAGS_CONFIRMATION_TEXT,
                    item: this.itemsToBeDeleted.length
                };
            }
            const [first] = this.itemsToBeDeleted;
            return {
                message: REMOVE_TAG_CONFIRMATION_TEXT,
                item: first?.path
            };
        },
        disablePrimaryButton () {
            return this.deleteImage && this.inputImageName !== this.imageName;
        },
        primaryActionProps () {
            return {
                text: __('Delete'),
                attributes: {
                    variant: 'danger',
                    disabled: this.disablePrimaryButton
                }
            };
        }
    },
    methods: {
        show () {
            this.$refs.deleteModal.show();
        }
    },
    modal: {
        cancelAction: {
            text: __('Cancel')
        }
    }
};
